import { render, staticRenderFns } from "./UpdateSidebar.vue?vue&type=template&id=0961d73c&scoped=true&"
import script from "./UpdateSidebar.vue?vue&type=script&lang=js&"
export * from "./UpdateSidebar.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSidebar.vue?vue&type=style&index=0&id=0961d73c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0961d73c",
  null
  
)

export default component.exports